module.exports = __webpack_public_path__ + "static/img/3en.fdbcb90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/3en.png
// module id = 4UMQ
// module chunks = 0